import React from "react";
import { LegalModal } from "./LegalModal";
import { LANDING } from "../constants/testIds/landing";
import { ShieldCheck } from "lucide-react";

export const Datenschutz = ({ isOpen, onClose }) => {
  return (
    <LegalModal
      isOpen={isOpen}
      onClose={onClose}
      title="Datenschutzerklärung"
      icon={ShieldCheck}
      testId={LANDING.datenschutzModal}
      closeTestId={LANDING.datenschutzCloseBtn}
    >
      <p>
        Der Schutz Ihrer persönlichen Daten ist mir ein besonderes Anliegen. Ich verarbeite Ihre
        Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2021). In
        diesen Datenschutzinformationen informiere ich Sie über die wichtigsten Aspekte der
        Datenverarbeitung im Rahmen meiner Website.
      </p>

      <div className="space-y-2 pt-4 border-t border-[#b58e70]/20">
        <h4 className="font-serif text-base text-[#1c110e] font-medium uppercase tracking-wider text-[#d97036]">
          1. Kontakt mit mir
        </h4>
        <p>
          Wenn Sie per E-Mail Kontakt mit mir aufnehmen, werden Ihre angegebenen Daten (wie
          E-Mail-Adresse, Name und der Inhalt Ihrer Nachricht) zwecks Bearbeitung der Anfrage und für
          den Fall von Anschlussfragen bei mir gespeichert. Diese Daten gebe ich nicht ohne Ihre
          Einwilligung weiter. Die Datenverarbeitung erfolgt zur Durchführung vorvertraglicher
          Maßnahmen bzw. zur Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO).
        </p>
      </div>

      <div className="space-y-2 pt-4 border-t border-[#b58e70]/20">
        <h4 className="font-serif text-base text-[#1c110e] font-medium uppercase tracking-wider text-[#d97036]">
          2. Server-Logfiles (Webhosting)
        </h4>
        <p>
          Der Anbieter dieser Website (Webhoster) erhebt und speichert automatisch Informationen in
          sogenannten Server-Logfiles, die Ihr Browser automatisch an uns übermittelt. Dies sind:
        </p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Browsertyp und Browserversion</li>
          <li>Verwendetes Betriebssystem</li>
          <li>Referrer URL (die zuvor besuchte Seite)</li>
          <li>Hostname des zugreifenden Rechners (IP-Adresse)</li>
          <li>Uhrzeit der Serveranfrage</li>
        </ul>
        <p>
          Diese Daten sind technisch notwendig, um Ihnen meine Website anzuzeigen und die Stabilität
          sowie Sicherheit der Seite zu gewährleisten. Die Rechtsgrundlage hierfür ist mein
          berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO). Diese Daten werden nach Ablauf der
          gesetzlichen oder technisch notwendigen Fristen automatisch vom Hoster gelöscht.
        </p>
      </div>

      <div className="space-y-2 pt-4 border-t border-[#b58e70]/20">
        <h4 className="font-serif text-base text-[#1c110e] font-medium uppercase tracking-wider text-[#d97036]">
          3. Cookies und Tracking
        </h4>
        <p>
          Diese Website verwendet keine Cookies, keine Tracking-Tools (wie Google Analytics) und
          keine Plugins von Drittanbietern (wie Social-Media-Buttons). Es werden beim Besuch dieser
          Website keine Nutzerprofile erstellt.
        </p>
      </div>

      <div className="space-y-2 pt-4 border-t border-[#b58e70]/20">
        <h4 className="font-serif text-base text-[#1c110e] font-medium uppercase tracking-wider text-[#d97036]">
          4. Ihre Rechte
        </h4>
        <p>
          Ihnen stehen bezüglich Ihrer bei mir gespeicherten Daten grundsätzlich die Rechte auf
          Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerruf und
          Widerspruch zu.
        </p>
        <p>
          Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder
          Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie
          sich bei mir oder bei der Datenschutzbehörde in Österreich beschweren.
        </p>
      </div>

      <div className="space-y-2 pt-4 border-t border-[#b58e70]/20">
        <h4 className="font-serif text-base text-[#1c110e] font-medium uppercase tracking-wider text-[#d97036]">
          5. Verantwortlicher für die Datenverarbeitung
        </h4>
        <p className="font-semibold text-[#1c110e]">Walter Unterberger</p>
        <p>1090 Wien</p>
        <p>Tel. +43 676 569 4291</p>
        <p>
          E-Mail:{" "}
          <a href="mailto:office@entreamigos.at" className="text-[#8a2424] hover:underline">
            office@entreamigos.at
          </a>
        </p>
      </div>
    </LegalModal>
  );
};
